var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarNoFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.942517L9.59775 4.29456L9.70471 4.46547L9.90031 4.51438L13.7365 5.47363L11.1968 8.50455L11.0673 8.65909L11.0812 8.86022L11.3544 12.8051L7.68699 11.3263L7.5 11.2509L7.31301 11.3263L3.64561 12.8051L3.91877 8.86022L3.9327 8.65909L3.80321 8.50455L1.26346 5.47363L5.09969 4.51438L5.29529 4.46547L5.40225 4.29456L7.5 0.942517Z",
    stroke: "#C7A267"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarNoFill);
export default __webpack_public_path__ + "static/media/StarNoFill.169a548858f3cd93ce3cfc130ce48f08.svg";
export { ForwardRef as ReactComponent };